module.exports = __webpack_public_path__ + "img/72-Metbrush Quartzgrau.jpg";